export class UpdateItemsInsideNodeMessage {
  nodeId: string | null | undefined = undefined;

  constructor(nodeId: string | null | undefined) {
    this.nodeId = nodeId;
  }
}